export default __webpack_public_path__ + "static/media/ic-edit-underline.3d67a521.svg";